import { Component, Input } from '@angular/core';

/**
 * Generic empty-state block.
 *
 * Renders inside the global `.empty-state` class (defined in _components.scss)
 * so no local style overrides are needed. Use `.es-actions` slot for action
 * buttons via `<ng-content>`.
 *
 * @example
 * <app-empty-state title="Žádné přestupy" description="Vytvořte první přestup."
 *                  icon="pi-arrows-h">
 *   <button class="btn btn-primary" (click)="create()">Přidat přestup</button>
 * </app-empty-state>
 */
@Component({
  selector: 'app-empty-state',
  template: `
    <div class="empty-state">
      <div class="es-icon">
        <i class="pi" [ngClass]="icon"></i>
      </div>
      <h3>{{ title }}</h3>
      <p>{{ description }}</p>
      <div class="es-actions">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `]
})
export class EmptyStateComponent {
  @Input() title: string = 'Žádná data k dispozici';
  @Input() description: string = 'Zatím zde nejsou žádné záznamy k zobrazení.';
  /**
   * PrimeIcons class name (without the leading "pi ").
   * Example: "pi-inbox", "pi-folder-open", "pi-arrows-h"
   */
  @Input() icon: string = 'pi-inbox';
}
